import {Component, OnDestroy, OnInit} from '@angular/core';
import {CoreConfigService} from '../../../../../@core/services/config.service';
import {AuthenticationService} from '../../../../core/service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {cnpRegex, emailRegex, isMobile} from '../../../../core/helpers/constants';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {CoreLoadingScreenService} from '../../../../../@core/services/loading-screen.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  providers: [TranslatePipe]
})
export class SignupComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  public coreConfig: any;
  public companyInfo: any;
  public logo: string = null;
  public companySignUpForm: FormGroup;
  emailFieldVisible = false;
  cnpDisabled = false;
  subdomain: string;
  isSuccess = false;
  constructor(private _coreConfigService: CoreConfigService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private translate: TranslatePipe,
    private loader: CoreLoadingScreenService,
  ) {
    this.subdomain = this.route.snapshot.params['subdomain'];
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
      },
    };

  }

  ngOnInit(): void {
    this.companySignUpForm = new FormGroup({
      cnp: new FormControl('', [Validators.required, Validators.pattern(cnpRegex)]),
      // email: new FormControl('', [Validators.required, Validators.pattern(emailRegex)]),
    });
    // // Subscribe to config changes
    this._coreConfigService.config
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((config) => {
        this.coreConfig = config;
      });

    this.authenticationService.currentUserCompanyInfo
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((info) => {
        this.companyInfo = info;
        if (!info.signUpEnabled) {
          this.router.navigate([`${this.subdomain}/home`]);
        }
        if (info) {
          this.logo = info.pictureUrl;
        }
      });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.companySignUpForm.controls;
  }

  signUp() {
    if (!this.emailFieldVisible) {
      // we have to check if the user with this cnp exists
      this.authenticationService.performCnpSignupCheck({
        subdomain: this.subdomain,
        cnp: this.f.cnp.value
      }).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: value => {
          this.cnpDisabled = true;
          this.companySignUpForm.addControl('email', new FormControl('', [Validators.required, Validators.pattern(emailRegex)]));
          this.emailFieldVisible = true;
        },
        error: err => this.showErrorToast(err)
      });
    } else {
      // let's try and submit the e-mail change
      this.authenticationService.completeSignUp({
        subdomain: this.subdomain,
        cnp: this.f.cnp.value,
        email: this.f.email.value
      }).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: value => {
          this.isSuccess = true;
        },
        error: err => {
          this.showErrorToast(err);
        }
      });
    }
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private showErrorToast(error: any) {
    if(error && error.messages) {
      error.messages.forEach((errorItem) => {
        this.toastrService.error(
          this.translate.transform(errorItem),
          this.translate.transform('ERROR'),
          { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
        );
      });
    }
  }

  protected readonly isMobile = isMobile;

}
